<template>
  <b-form-group :label="label" :description="description" :invalid-feedback="validationError">
    <b-form-checkbox-group v-model="content" @input="updateContent()" :options="options" :state="state" :name="name" :stacked="stacked" />
  </b-form-group>
</template>

<script>
export default {
  name: "CheckBoxListControl",
  props: {
    label: {},
    name: {
      required: true
    },
    delimiter: {
      // If there's a delimiter, then the bound model value is a list separated by that delimier, e.g. "A|B|C" instead of an array ["A", "B", "C"]
      default: null
    },
    stacked: {
      default: true
    },
    description: {},
    options: {},
    value: {
      required: true
    },
    required: {
      default: false
    },
    requiredError: {
      default: 'This field is required'
    },
    customValidation: {}
  },
  data() {
    return {
      content: this.delimiter ? (this.value && this.value.length > 0 ? this.value.split(this.delimiter) : []) : this.value,
      originalValue: this.delimiter ? (this.value && this.value.length > 0 ? this.value.split(this.delimiter) : []) : this.value,
      state: null,
      validationError: null
    };
  },
  computed: {
    isValid: function () {
      if (this.state === null)
        this.checkValidity(this.content, this.content);

      return this.state === true || this.state === null;
    }
  },
  methods: {
    updateContent() {
      this.$emit('input', this.delimiter ? (this.content && this.content.length > 0 ? this.content.join(this.delimiter) : '') : this.content);
    },
    checkValidity(newValue, oldValue) {
      let validationError = null;

      if (this.required !== null && this.required !== false && (newValue == null || newValue == ''))
        validationError = this.requiredError;
      else if (typeof(this.customValidation) === 'function') {
        let retVal = this.customValidation(newValue, oldValue);
        if (retVal !== true && retVal !== null)
          validationError = retVal;
        else {
          this.state = retVal;
          validationError = null;
        }
      }

      this.validationError = validationError;
      if (this.validationError != null)
        this.state = false;
      else {
        if (this.originalValue == newValue)
          this.state = null;
        else
          this.state = true;
      }
    }
  },
  watch: {
    content: function (newValue, oldValue) {
      this.checkValidity(newValue, oldValue);
    }
  },
  mounted () {
  }
};
</script>